module.exports = __webpack_public_path__ + "img/13.ba08a19d.png";